import { StorageKey } from '@airgap/beacon-types';
import { P2PTransport } from '@airgap/beacon-transport-matrix';
// const logger = new Logger('DappP2PTransport')
/**
 * @internalapi
 *
 *
 */
export class WalletP2PTransport extends P2PTransport {
    constructor(name, keyPair, storage, matrixNodes, iconUrl, appUrl) {
        super(name, keyPair, storage, matrixNodes, StorageKey.TRANSPORT_P2P_PEERS_WALLET, iconUrl, appUrl);
    }
    async addPeer(newPeer, sendPairingResponse = true) {
        await super.addPeer(newPeer);
        if (sendPairingResponse) {
            await this.client.sendPairingResponse(newPeer); // TODO: Should we have a confirmation here?
        }
    }
}
//# sourceMappingURL=WalletP2PTransport.js.map